<template>
  <div class="bar-chart-scroll">
    <div class="bar-chart-container">
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  name: 'LabelsBarChart',
  props: {
    labelsData: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.updateChart();
  },
  watch: {
    labelsData: {
      immediate: true,
      handler() {
        if (this.labelsData && this.labelsData.length > 0) {
          this.updateChart();
        }
      },
    },
  },
  methods: {
    updateChart() {
      const countsByDate = {};

      this.labelsData.forEach(entry => {
        const date = new Date(entry.created_at).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'short',
        });

        countsByDate[date] = (countsByDate[date] || 0) + 1;
      });

      const labels = Object.keys(countsByDate);
      const data = Object.values(countsByDate);

      const chartData = {
        labels,
        datasets: [
          {
            label: this.$t('LABELS_REPORTS.CHART.TOTAL_LABELS'),
            backgroundColor: '#007bff',
            data,
          },
        ],
      };

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: {
            boxWidth: 12,
            padding: 20,
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };

      this.renderChart(chartData, chartOptions);
    },
  },
};
</script>

<style scoped>
.bar-chart-scroll {
  overflow-x: auto;
  width: 100%;
}

.bar-chart-container {
  position: relative;
  height: 300px;
  min-width: 900px;
}
</style>
